document.addEventListener("click", function(e) {
  const btn = e.target.closest(".variant-option__button-label");
  if (!btn) return;
   const productForm = document.querySelector("[bss-b2b-main-product-form]");
    BSS_B2B.observer.productSubject.notifyObserver('VariantChange', 'VariantSelectChange', {
        productForm
    });
});